import api from "@/lib/axios";
import { useNavigate } from 'react-router-dom';

export const FrontendService = {
  //get compaigns data  
  getCampaignBySlug: async (companySlug, campaignSlug) => {
    try {
      const { data } = await api.get(`/${companySlug}/${campaignSlug}`);
      return data?.data ?? data;

    } catch (error) {
      console.log("error message", error);
      if (error.response) { 
        if (error.response.status === 404) {
          window.location.href = '/404';
          return null;
        }
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';
        const fieldErrors = apiError.errors || {};
        throw new Error("Failed to fetch campaign: " + message);
      } else {
        throw new Error("Failed to fetch campaign: " + error.message);
      }
    }
  },

  // Add this to the campaignsService object
  getVacancyBySlug: async (companySlug, campaignSlug, vacancySlug) => {
    try {
      const { data } = await api.get(`/${vacancySlug}`);
      return data?.vacancy ?? data;

    } catch (error) {
      console.log("error message", error);
      if (error.response) { 
        if (error.response.status === 404) {
          window.location.href = '/404';
          return null;
        }
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';
        const fieldErrors = apiError.errors || {};
        throw new Error("Failed to fetch vacancy: " + message);
      } else {
        throw new Error("Failed to fetch vacancy: " + error.message);
      }
    }
  },

  
  applicationSubmission:async (applicationData) => {
    try {
      const response = await api.post("/applications", applicationData,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          window.location.href = '/404';
          return null;
        }
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';
        const fieldErrors = apiError.errors || {};
        const throwableError = new Error(message);
        throwableError.errors = fieldErrors;
        throw throwableError;
      } else {
        console.log( error.message);
        throw new Error(  error.message);
      }
    }
  },
};

